module.exports = __webpack_public_path__ + "img/room-event-star_in.b8a9c71f.png";